import { render, staticRenderFns } from "./PasswordConfirm.vue?vue&type=template&id=707bfa5c&scoped=true&"
import script from "./PasswordConfirm.vue?vue&type=script&lang=js&"
export * from "./PasswordConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordConfirm.vue?vue&type=style&index=0&id=707bfa5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707bfa5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VDialog,VSpacer,VTextField})
